import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
  Update,
} from '@reduxjs/toolkit'
import { ICustomFieldFormSetting } from '../entityFormSettings'
import { StoreData } from '../reducers/typings'
import {
  getAllCustomFieldsSettings,
  toggleCustomFieldEnabled,
  toggleCustomFieldRequired,
} from './api'

const customFieldsSettingsAdapter =
  createEntityAdapter<ICustomFieldFormSetting>({
    selectId: (setting) => setting.customFieldId,
    sortComparer: (a, b) => {
      return a.order - b.order
    },
  })

export const initialState = customFieldsSettingsAdapter.getInitialState()
const customFieldsSettingsSlice = createSlice({
  name: 'customFieldsSettingsSlice',
  initialState: initialState,
  reducers: {
    setCustomFieldsSettingsOrder: (
      state,
      { payload }: PayloadAction<{ id: number; order: number }[]>,
    ) => {
      const update: Update<ICustomFieldFormSetting>[] = payload.map((s) => ({
        id: s.id,
        changes: { order: s.order },
      }))
      customFieldsSettingsAdapter.updateMany(state, update)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getAllCustomFieldsSettings.fulfilled,
      (state, { payload }) => {
        customFieldsSettingsAdapter.setAll(state, payload)
      },
    )

    builder.addCase(
      toggleCustomFieldRequired.fulfilled,
      (state, { payload }) => {
        const { id, toggleState } = payload
        customFieldsSettingsAdapter.updateOne(state, {
          id,
          changes: { required: toggleState },
        })
      },
    )
    builder.addCase(
      toggleCustomFieldEnabled.fulfilled,
      (state, { payload }) => {
        const { id, toggleState } = payload
        customFieldsSettingsAdapter.updateOne(state, {
          id,
          changes: { enabled: toggleState },
        })
      },
    )
  },
})

export const { setCustomFieldsSettingsOrder } =
  customFieldsSettingsSlice.actions

export const customFieldsSettingsReducer = customFieldsSettingsSlice.reducer

export const { selectAll: selectAllCustomFieldsSettings } =
  customFieldsSettingsAdapter.getSelectors<StoreData>(
    (state) => state.customFieldsFormSettings,
  )
